import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import salaryService from "./salaryService";

export const getSalary = createAsyncThunk(
  "salary/get-salarys",
  async (queryParams = {}, thunkAPI) => {
    try {
      const data = await salaryService.getSalarys(queryParams);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createMonthSalary = createAsyncThunk(
  "salary/create-monthsalary",
  async (salaryData, thunkAPI) => {
    try {
      return await salaryService.createMonthSalary(salaryData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateASalary = createAsyncThunk(
  "salary/update-salary",
  async (salary, thunkAPI) => {
    try {
      return await salaryService.updateSalary(salary);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updatePaidSalary = createAsyncThunk(
  "salary/update-paid-salary",
  async ({ id, salaryData }, thunkAPI) => {
    try {
      return await salaryService.updatePaidSalary(id, salaryData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createQuarterSalary = createAsyncThunk(
  "salary/create-quartersalary",
  async (salaryData, thunkAPI) => {
    try {
      return await salaryService.createQuarterSalary(salaryData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getASalary = createAsyncThunk(
  "salary/get-salary",
  async (id, thunkAPI) => {
    try {
      return await salaryService.getOneSalary(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteASalary = createAsyncThunk(
  "salary/delete-salary",
  async (id, thunkAPI) => {
    try {
      return await salaryService.deleteSalary(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteSalaryRecord = createAsyncThunk(
  "salary/delete-salary-record",
  async (id, thunkAPI) => {
    try {
      return await salaryService.deleteSalaryRecord(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getOneSalary = createAsyncThunk(
  "salary/get-onesalary",
  async (id, thunkAPI) => {
    try {
      return await salaryService.getOneSalary(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const csvDownload = createAsyncThunk(
  "salary/csv-download",
  async (_, thunkAPI) => {
    try {
      return await salaryService.csvDownload();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadCsv = createAsyncThunk(
  "salryrecord/storemonthlyViaFile",
  async (params, thunkAPI) => {
    try {
      return await salaryService.uploadCsv(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const getUsersByStateAndDistrict = createAsyncThunk(
  "salary/get-users-by-state-district",
  async ({ state_code, district }, thunkAPI) => {
    try {
      return await salaryService.getUsersByStateAndDistrict({
        state_code,
        district,
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  salaries: [],
  createdMonthSalary: [],
  createdQuarterSalary: [],
  oneSalary: [],
  uploadedData: [],
  csvData: [],
  filteredUsers: [],
  isError: false,
  isLoading: false,
  loading: false,
  Loading: false,
  isSuccess: false,
  message: "",
  summary: {},
};

export const salarySlice = createSlice({
  name: "salary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.salaries = action.payload.salaries || [];
        state.summary = action.payload.summary || {};
      })
      .addCase(getSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createMonthSalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMonthSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMonthSalary = action.payload;
      })
      .addCase(createMonthSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createQuarterSalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createQuarterSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdQuarterSalary = action.payload;
      })
      .addCase(createQuarterSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateASalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateASalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedSalary = action.payload;
      })
      .addCase(updateASalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updatePaidSalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePaidSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.salaries = state.salaries.map((salary) =>
          salary._id === action.meta.arg.id
            ? {
                ...salary,
                total_paid_amount:
                  action.payload.salaryPaid || salary.total_paid_amount,
                tds_deducted:
                  action.payload.tds_deducted || salary.tds_deducted,
                adjustments: action.payload.adjustments || salary.adjustments,
                additionalPaidAmount:
                  action.payload.additionalPaidAmount ||
                  salary.additionalPaidAmount,
              }
            : salary
        );
      })
      .addCase(updatePaidSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getASalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getASalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(getASalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteASalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteASalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.salaries = state.salaries.filter(
          (salary) => salary._id !== action.meta.arg
        );
      })
      .addCase(deleteASalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteSalaryRecord.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSalaryRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.salaries = state.salaries.filter(
          (salary) => salary._id !== action.meta.arg
        );
      })
      .addCase(deleteSalaryRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getOneSalary.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOneSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.oneSalary = action.payload;
      })
      .addCase(getOneSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(csvDownload.pending, (state) => {
        state.loading = true;
      })
      .addCase(csvDownload.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.isSuccess = true;
        state.csvData = action.payload;
      })
      .addCase(csvDownload.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(uploadCsv.pending, (state) => {
        state.Loading = true;
      })
      .addCase(uploadCsv.fulfilled, (state, action) => {
        state.Loading = false;
        state.isError = false;
        state.isSuccess = true;
        state.uploadedData = action.payload;
      })
      .addCase(uploadCsv.rejected, (state, action) => {
        state.Loading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getUsersByStateAndDistrict.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUsersByStateAndDistrict.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.filteredUsers = action.payload || [];
      })
      .addCase(getUsersByStateAndDistrict.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default salarySlice.reducer;
